/** Shared with Candidate / Client / Job detail toolbars — icon + bracket label row actions. */
export const detailTbBtn =
  'inline-flex items-center gap-1.5 px-2.5 py-1.5 text-xs font-semibold rounded-md transition-colors cursor-pointer';
export const detailTbNeutral =
  'text-slate-700 hover:text-slate-900 hover:bg-slate-200/90 dark:text-gray-300 dark:hover:text-white dark:hover:bg-gray-700';
/** Edit / secondary — avoids neutral `--vscode-primary` in dark (was invisible on toolbar). */
export const detailTbEdit =
  'vscode-text-secondary hover:vscode-text-primary hover:vscode-bg-hover';
export const detailTbDanger =
  'text-red-700 hover:text-red-900 hover:bg-red-500/12 dark:text-red-400 dark:hover:text-red-200 dark:hover:bg-red-500/10';
